import type { RouteObject } from 'react-router-dom';
import { Navigate } from 'react-router-dom';

import { RequireSection } from '@/shared/routing';

import { CustomerDetailPage } from './ui/pages/CustomerDetailPage';
import { CustomersListPage } from './ui/pages/CustomersListPage';

/**
 * Customer-base CRM subtree, mounted under the authenticated `AppLayout` shell.
 * `/customers` is the searchable directory; `/customers/:customerId` opens the
 * full customer profile (contacts, consents, addresses, recipients, accounts, loyalty).
 */
export const customersRoutes: RouteObject = {
  path: 'customers',
  element: <RequireSection section="customers" />,
  children: [
    { index: true, element: <CustomersListPage /> },
    { path: ':customerId', element: <CustomerDetailPage /> },
    { path: '*', element: <Navigate to="/customers" replace /> },
  ],
};
